import React, { useMemo } from 'react';
import { TbPlayerTrackNextFilled } from 'react-icons/tb';
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    Tooltip,
    useToast
} from '@chakra-ui/react';

import { useStore } from 'commons/hooks';
import { TransportRequestTag } from 'data/schemas/TransportRequest';
import { FaEdit } from 'react-icons/fa';
import { FaDownload } from 'react-icons/fa6';

type Props = {
    transportRequestTag: TransportRequestTag[];
    onClickDeploy: (tag: TransportRequestTag) => void;
    onClickShowModalEdit: (transportRequest: TransportRequestTag) => void;
    onClickDowloadFile: (uatTag: string) => void;
    onClickShowModalReadyForPrd: (uatTag: TransportRequestTag) => void;
};

function TransportRequestTable(props: Props) {
    const {
        transportRequestTag,
        onClickDeploy,
        onClickShowModalEdit,
        onClickDowloadFile,
        onClickShowModalReadyForPrd
    } = props;
    const { authentication } = useStore();
    const toast = useToast();

    const headers = useMemo(
        () => [
            '',
            '',
            'Deploy',
            'Ready For Prd',
            'UAT TAG',
            'Module',
            'Deployment Object',
            'Version',
            'Status',
            'Ticket',
            'Detail',
            'Remark',
            'Feature',
            'Core / Non Core',
            'Add / Edit',
            'Impact',
            'Risk Level',
            'Developer'
        ],
        []
    );

    const employeeData = authentication.masterEmployeeResponse;

    const CopyToClipboard = (tagDetail: TransportRequestTag) => {
        const { uatTag, developer, details } = tagDetail;
        const detailsWithTextWrap = '"' + details.trim() + '"';
        const nullStringRegEx = new RegExp('null', 'g');

        const outputLines = tagDetail.transportRequestDetail.map((detail, index) => {
            const {
                module,
                deploymentObject,
                version,
                ticket,
                feature,
                coreOrNonCore,
                addOrEdit,
                impact,
                riskLevel
            } = detail;

            if (index === 0) {
                const fistRowClipboardMessage =
                    uatTag +
                    '\t' +
                    developer +
                    '\t' +
                    module.toUpperCase() +
                    '\t' +
                    deploymentObject +
                    '\t' +
                    version +
                    '\t' +
                    ticket +
                    '\t' +
                    detailsWithTextWrap +
                    '\t' +
                    feature +
                    '\t' +
                    coreOrNonCore +
                    '\t' +
                    addOrEdit +
                    '\t' +
                    impact +
                    '\t' +
                    riskLevel;

                return fistRowClipboardMessage.replace(nullStringRegEx, '');
            }

            const clipboardMessage =
                '\t' +
                '\t' +
                module.toUpperCase() +
                '\t' +
                deploymentObject +
                '\t' +
                version +
                '\t' +
                //ticket +
                '\t' +
                //details +
                '\t' +
                //feature +
                '\t' +
                coreOrNonCore +
                '\t' +
                addOrEdit +
                '\t' +
                //impact +
                '\t';
            //riskLevel;

            return clipboardMessage.replace(nullStringRegEx, '');
        });

        toast({ title: 'Copied', status: 'success', duration: 2000 });
        navigator.clipboard.writeText(outputLines.join('\n'));
    };

    return (
        <TableContainer
            whiteSpace="wrap"
            className="mt-2"
        >
            <Table
                size="sm"
                variant="unstyled"
            >
                <Thead>
                    <Tr>
                        {headers.map(header => (
                            <Th
                                key={header}
                                className="m-0 border p-2 text-center"
                                style={{
                                    borderColor:
                                        'rgb(212 212 212 / var(--tw-border-opacity)) !important'
                                }}
                            >
                                {header}
                            </Th>
                        ))}
                    </Tr>
                </Thead>
                <Tbody className="overflow-x-scroll">
                    {transportRequestTag ? (
                        transportRequestTag.map((tag, rowIndex) => {
                            const rowSpan = tag.transportRequestDetail.length;

                            return tag.transportRequestDetail.map((detail, detailIndex) => (
                                <Tr
                                    key={tag.uatTag + detailIndex}
                                    className={`hover:bg-cyan-200 [&>td]:border [&>td]:border-neutral-300 ${detail.deployStatus === 'Online' && detail.deployCompany.split(',').length === 20 ? 'bg-green-50' : ''}`}
                                    onDoubleClick={() => {
                                        CopyToClipboard(tag);
                                    }}
                                >
                                    {detailIndex === 0 && (
                                        <React.Fragment>
                                            <Td
                                                rowSpan={rowSpan}
                                                className="cursor-pointer px-2 py-0.5 text-center"
                                                onClick={() => onClickDowloadFile(tag.uatTag)}
                                            >
                                                <FaDownload className="text-green-500" />
                                            </Td>
                                            <Td
                                                rowSpan={rowSpan}
                                                className="cursor-pointer px-2 py-0.5 text-center"
                                                onClick={() => onClickShowModalEdit(tag)}
                                            >
                                                <FaEdit className="text-yellow-500" />
                                            </Td>
                                            <Td
                                                className="m-0 px-2 py-0.5 text-center"
                                                rowSpan={rowSpan}
                                            >
                                                <button
                                                    onClick={() => onClickDeploy(tag)}
                                                    disabled={
                                                        (detail.deployStatus === 'Online' &&
                                                            detail.deployCompany.split(',')
                                                                .length === 20) ||
                                                        (employeeData?.type !== 'super_admin' &&
                                                            employeeData?.ctizenID !==
                                                                tag.developer)
                                                    }
                                                >
                                                    <TbPlayerTrackNextFilled
                                                        size={24}
                                                        className={`m-0 p-0 ${
                                                            (detail.deployStatus === 'Online' &&
                                                                detail.deployCompany.split(',')
                                                                    .length === 20) ||
                                                            (employeeData?.type !== 'super_admin' &&
                                                                employeeData?.ctizenID !==
                                                                    tag.developer)
                                                                ? 'pointer-events-none text-gray-600'
                                                                : 'text-green-600'
                                                        }`}
                                                    />
                                                </button>
                                            </Td>
                                        </React.Fragment>
                                    )}
                                    <Td className="m-0 px-2 py-0.5 text-center">
                                        <input
                                            type="checkbox"
                                            defaultChecked={detail.readyForPrd}
                                            checked={detail.readyForPrd}
                                            disabled={detail.readyForPrd}
                                            onClick={() => onClickShowModalReadyForPrd(tag)}
                                        />
                                    </Td>
                                    {detailIndex === 0 && (
                                        <Td
                                            rowSpan={rowSpan}
                                            className="m-0 whitespace-nowrap text-nowrap px-2 py-0.5"
                                        >
                                            {tag.uatTag}
                                        </Td>
                                    )}
                                    <Td className="m-0 px-2 py-0.5 text-center">
                                        <span>{detail.module.toUpperCase()}</span>
                                    </Td>
                                    <Td className="m-0 max-w-[460px] truncate px-2 py-0.5">
                                        <Tooltip
                                            label={detail.deploymentObject}
                                            placement="top"
                                        >
                                            <span>{detail.deploymentObject}</span>
                                        </Tooltip>
                                    </Td>
                                    <Td className="m-0 px-2 py-0.5 text-left">
                                        <span>{detail.version}</span>
                                    </Td>
                                    <Td
                                        className={`m-0 px-2 py-0.5 text-center ${
                                            detail.deployStatus === 'Online'
                                                ? 'font-bold text-green-600'
                                                : 'font-bold text-yellow-500'
                                        }`}
                                    >
                                        {detail.deployStatus}
                                    </Td>
                                    {detailIndex === 0 && (
                                        <React.Fragment>
                                            <Td
                                                rowSpan={rowSpan}
                                                className="m-0 max-w-[460px] truncate px-2 py-0.5"
                                            >
                                                <Tooltip
                                                    label={detail.ticket}
                                                    placement="top-start"
                                                >
                                                    <span>{detail.ticket}</span>
                                                </Tooltip>
                                            </Td>
                                            <Td
                                                rowSpan={rowSpan}
                                                className="m-0 max-w-[460px] truncate px-2 py-0.5"
                                            >
                                                <Tooltip
                                                    label={tag.details}
                                                    placement="top-start"
                                                >
                                                    <span>{tag.details}</span>
                                                </Tooltip>
                                            </Td>
                                            <Td
                                                className="m-0 min-w-[150px] max-w-[460px] truncate px-2 py-0.5 text-red-400"
                                                rowSpan={rowSpan}
                                            >
                                                <Tooltip
                                                    label={detail.remark}
                                                    placement="top-start"
                                                >
                                                    <span>{detail.remark}</span>
                                                </Tooltip>
                                            </Td>
                                            <Td
                                                rowSpan={rowSpan}
                                                className="m-0 px-2 py-0.5"
                                            >
                                                {detail.feature}
                                            </Td>
                                        </React.Fragment>
                                    )}
                                    <Td className="m-0 px-2 py-0.5">{detail.coreOrNonCore}</Td>
                                    <Td className="m-0 px-2 py-0.5">{detail.addOrEdit}</Td>
                                    {detailIndex === 0 && (
                                        <React.Fragment>
                                            <Td
                                                rowSpan={rowSpan}
                                                className="m-0 w-[460px] truncate px-2 py-0.5"
                                            >
                                                <Tooltip
                                                    label={detail.impact}
                                                    placement="top-start"
                                                >
                                                    <span>{detail.impact}</span>
                                                </Tooltip>
                                            </Td>
                                            <Td
                                                className="m-0 px-2 py-0.5 text-center"
                                                rowSpan={rowSpan}
                                            >
                                                {detail.riskLevel}
                                            </Td>
                                            <Td
                                                className="m-0 px-2 py-0.5"
                                                rowSpan={rowSpan}
                                            >
                                                {tag.developer}
                                            </Td>
                                        </React.Fragment>
                                    )}
                                </Tr>
                            ));
                        })
                    ) : (
                        <tr className="text-center">
                            <td colSpan={headers.length}>
                                <span>No data..</span>
                            </td>
                        </tr>
                    )}
                </Tbody>
            </Table>
        </TableContainer>
    );
}

export default TransportRequestTable;
